import { useQuery } from '@tanstack/react-query';
import { useQueryCreator } from '~/hooks/useQueryCreator';
import { partnerService } from '~/services';
import type { Partner } from '../../store/services/PartnerService/types';

// Create a wrapper to match the expected pattern for useQueryCreator
const partnerQuery = {
  queryKey: 'partner',
  configurationType: 'default' as const,
  fn: (partnerId: string): Promise<Partner> => partnerService.fetchPartner(partnerId),
};

interface UsePartnerOptions {
  partnerId: string;
}

export const usePartner = (options: UsePartnerOptions) => {
  const partnerId = options.partnerId;

  return useQuery({
    ...useQueryCreator(partnerQuery, {
      args: [partnerId],
    }),
    refetchOnMount: true,
    enabled: !!partnerId, // Only run query if we have a partner ID
  });
};
